import { useState } from 'react';

import { Dialog, DialogContent, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
import Box from '@mui/material/Box';

export const TextAreaViewCell = ({ value, isBold = false }) => {
  const [open, setOpen] = useState(false); // State for modal view
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Detect mobile view

  const handleCellClick = () => {
    if (isMobile) {
      setOpen(true); // Open modal on mobile click
    }
  };

  return (
    <>
      {/*Tooltip for non-mobile view*/}
      <Tooltip
        title={value || ''}
        arrow
        placement="top"
        disableHoverListener={isMobile} // Disable tooltip on mobile
      >
        <Box
          onClick={handleCellClick}
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'pointer',
            fontWeight: isBold ? 'bold' : 'none',
          }}
        >
          {value}
        </Box>
      </Tooltip>

      {/*Modal for mobile view*/}
      {isMobile && (
        <Dialog open={open} onClose={() => setOpen(false)}>
          <DialogContent>
            <Typography
              sx={{
                wordWrap: 'break-word', // Wrap text
                whiteSpace: 'normal', // Ensure multiline display
                fontWeight: isBold ? 'bold' : 'none',
              }}
            >
              {value || 'No content available'}
            </Typography>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};
